
































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
class  PageProductPricingRequest extends PageRequest{
    keyword:string;
    clientCode: string;
    customerType: string; 
    pricingTerm:string;
    fromDate:Date;
    toDate:Date;
}

@Component

export default class ProductPricing extends mixins(ListMixin, AbpBase){
    namespace = 'productPricing';
    pagerequest:PageProductPricingRequest=new PageProductPricingRequest();
    clients=[];
    customerTypes =[];
    pricingTerms=[];
    spinShow:boolean=false;
    creationTime:Date[]=[];
    get store () {
      return this.$store.state.productPricing;
    }
    async getClients(){
       await this.$store.dispatch({
            type:'client/getListForSelect',
            data:{ hasAllItem: true}
        }).then(result =>{
          var re = this.$store.state.client.clientsForSelect;
          this.pagerequest.clientCode = re.length === 0 ? "" : re[0].code;
          this.clients = re;
          this.changeClientCode();
        });
    }
    async getCustomerTypes(){
      await this.$store.dispatch({
            type:'customerType/getClientCustomerType',
            data: { clientCode : this.pagerequest.clientCode,hasAllItem: true}
        }).then(result => {
              var re = result;
              this.pagerequest.customerType = re.length === 0 ? "" : re[0].id;
              this.customerTypes =  re;
        });
     
    }
     async getPricingTerms()
    {
         await this.$store.dispatch({
                type:'productPricing/getPricingTerms',
                data: {  hasAllItem: true}
            })
            .then((result) => {
                this.pricingTerms = result;
                this.pagerequest.pricingTerm = this.pricingTerms.length === 0 ? "" : this.pricingTerms[0].id;
            });
    }
    async changeClientCode()
    {
        await this.getCustomerTypes();
    }
    viewProductPricing(id:string)
    {
        this.$root.$router.push({name: 'view/productpricing/:id', params: {id: id}})
    }
    createProductPricing()
    {
        this.$root.$router.push({name: 'create/productpricing'})
    }
    updateProductPricing(id:string)
    {
        this.$root.$router.push({name: 'update/productpricing/:id', params:{id:id}})
    }
    get list(){
      var re = this.$store.state.productPricing.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      return re;
    }
    preGetPage () {
     
      if (this.creationTime.length>0) {
          this.pagerequest.fromDate=this.creationTime[0];
      }
      if (this.creationTime.length>1) {
          this.pagerequest.toDate=this.creationTime[1];
      }
    }
    async exportToExcel () {
      this.preGetPage();
      await this.$store.dispatch({
        type: "productPricing/exportProductProductPricings",
        data: this.pagerequest
      });
    }
    columns= [
        {
          title:Util.L('Order'),
          key:'orderNo',
          width: 80,
        },
        {
              title:Util.L('Client'),
              key:'clientName'
          },
         {
              title:Util.L('PricingProfile'),
              key:'profileDisplayName'
          },{
              title:Util.L('PricingTerm'),
              key:'pricingTermName'
          },{
              title:Util.L('SKU'),
              key:'sku'
          },
          {
              title:Util.L('ProductName'),
              key:'productName'
          },
          {
              title:Util.L('Price'),
              key:'price',
              align: 'right',
              render: (h:any,params:any) =>{
                return h('span', Util.toViewNumberString(params.row.price));
              }
          }
          ,{
              title:Util.L('CreationTime'),
              key:'creationTime',
              render:(h:any,params:any)=>{
                  return h("span", Util.toViewDateString(params.row.creationTime));
              }
          }
         ,{
            title: Util.L('Action'),
            width:100,
            fixed:'right',
            slot: 'action',
            align: 'center'
        }]
    async created(){
      this.spinShow=true;
      try {
        await this.getClients();
        await this.getPricingTerms();
        var defaultDate = new Date();
        this.creationTime = [defaultDate,defaultDate];
        this.spinShow = false;
      } catch (error) {
        this.spinShow = false;
      }
    }
}
